<template>
  <div>
    <dw-survey-dcs-wrapper :id="id" is-answer-export="true" @getDate="setDate" >
      <template v-slot:dw-dcs-main-slot="{survey}" >
        <div class="dw-dcs-main-title">
          <el-row type="flex">
            <el-col :span="18"><div style="font-size: 14px;padding: 10px;"><strong>导出文件列表</strong></div></el-col>
          </el-row>
        </div>
        <el-table
          :data="tableData"
          stripe
          style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="创建人姓名" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.createName" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.createName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" >
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件名称" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.description" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.description"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="文件状态" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.status" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.status"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="完成时间" >
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.modifiedTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" >
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip effect="dark" content="下载文件" placement="top">
                  <el-button size="mini" icon="el-icon-download" @click="handleGo(`${scope.row.fileUrl}`)"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="删除文件" placement="top">
                  <el-button size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="dw-pagination">
          <el-pagination
            :page-size="pageSize"
            :current-page="currentPage"
            :total="total"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>
    </dw-survey-dcs-wrapper>
  </div>
</template>
<script>

import DwSurveyDcsWrapper from '@/components/common/DwSurveyDcsWrapper'
import {surveyAnswerExportDelete, surveyAnswerExportList} from '@/api/dw-survey'
export default {
  name: 'DwSurveyAnswerExport',
  components: {
    DwSurveyDcsWrapper
  },
  data () {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0
    }
  },
  mounted () {
    this.queryList(1)
  },
  methods: {
    setDate (val) {
      this.queryList(1)
    },
    handleGo: function (url) {
      window.open('https://qiniuexport.gongxueyun.com/'+url, '_blank')
    },
    handleDelete (index, row) {
      console.log(index, row)
      this.$msgbox.confirm('确认删除此条记录吗？', '删除警告', {type: 'warning', confirmButtonText: '确认删除'}).then(() => {
        surveyAnswerExportDelete(row.id).then((response) => {
          console.log(response)
          const httpResult = response.data
          if (httpResult.resultCode === 200) {
            this.$message.success('删除成功，即将刷新数据。')
            this.queryList(1)
          } else {
            this.$message.error('删除记录失败')
          }
        })
      }).catch(() => {})
    },
    handleCurrentChange (val) {
      this.queryList(val)
    },
    queryList (pageNo) {
      surveyAnswerExportList(this.pageSize, pageNo).then((response) => {
        const resultData = response.data.data
        this.tableData = resultData
        this.total = response.data.total
        this.currentPage = response.data.current
        this.pageSize = response.data.pageSize
      })
    }
  }
}

</script>
<style scoped>
.dw-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/DwSurveyAnswerExport.vue